export enum UserRole {
  ADMIN = 'ADMIN',
  STAF = 'STAF',
  USER = 'USER',
}

export enum UserStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
}

export interface IUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  status: UserStatus;
  phone: string | null;
  avatarUrl: string | null;
  position: string | null;
  zones: IZoneBase[];
  topics: ITopicBase[];
  createdAt: string;
  updatedAt: string;
  lastLoginAt: string | null;
  mustChangePassword: boolean;
}

export interface IUserCreate {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  phone?: string;
  position?: string;
  zoneIds?: string[];
  topicIds?: string[];
}

export interface IUserUpdate {
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  status?: UserStatus;
  phone?: string;
  position?: string;
  zoneIds?: string[];
  topicIds?: string[];
}

export interface IZoneBase {
  id: string;
  name: string;
  slug: string;
}

export interface ITopicBase {
  id: string;
  name: string;
  slug: string;
}

export interface IImportResult {
  email: string;
  success: boolean;
  error?: string;
}

export interface IImportBatchResult {
  total: number;
  succeeded: number;
  failed: number;
  results: IImportResult[];
}
